import { useBetaPlan } from "./useBetaPlan";
import { useEnterprisePlan } from "./useEnterprisePlan";

/**
 * Returns true when the user can self-serve billing changes from the
 * dashboard — switching plans, cancelling, reactivating, etc.
 *
 * Enterprise users go through their account manager; beta users are on
 * a server-provisioned tier with locked billing. Both are excluded.
 */
export function useIsSelfServeBilling() {
  const isEnterprisePlan = useEnterprisePlan();
  const isBetaPlan = useBetaPlan();
  return !isEnterprisePlan && !isBetaPlan;
}
